import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

// Resolve any stored media path to a usable URL.
// - full http(s) URLs are used as-is
// - /api/uploads/... (admin-uploaded) are prefixed with the backend origin
// - /assets/... (bundled) are served by the frontend
export function mediaUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/")) return `${BACKEND}${path}`;
  return path;
}

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lwa_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

// Content helpers
export const listContent = (coll) => api.get(`/content/${coll}`).then((r) => r.data);
export const createContent = (coll, body) => api.post(`/content/${coll}`, body).then((r) => r.data);
export const updateContent = (coll, id, body) => api.put(`/content/${coll}/${id}`, body).then((r) => r.data);
export const deleteContent = (coll, id) => api.delete(`/content/${coll}/${id}`).then((r) => r.data);
export const uploadImage = (formData) => api.post(`/upload`, formData).then((r) => r.data);
